import { createElementBlock as t, openBlock as n, createElementVNode as e } from "vue";
import l from "./index289.js";
const r = {}, c = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 60 60"
};
function s(a, o, f, i, p, d) {
  return n(), t("svg", c, o[0] || (o[0] = [
    e("g", {
      fill: "none",
      "fill-rule": "evenodd"
    }, [
      e("path", {
        fill: "#FFF3AB",
        d: "M47 36.417A17.138 17.138 0 0 1 31.14 47C21.673 47.002 14 39.373 14 29.964 14 21.052 20.887 13.749 29.657 13c-4.366 5.973-3.857 14.372 1.562 19.76C35.49 37.003 41.641 38.21 47 36.416Z"
      }),
      e("path", {
        fill: "#000",
        "fill-rule": "nonzero",
        d: "M29.551 11.755c-9.47.808-16.801 8.7-16.801 18.209 0 10.102 8.236 18.289 18.39 18.286 7.528 0 14.207-4.542 17.016-11.357.408-.99-.537-2.002-1.553-1.662-5.057 1.694-10.673.448-14.503-3.358a13.947 13.947 0 0 1-1.434-18.135c.633-.866-.046-2.075-1.115-1.983Zm-2.683 3.008.312-.083-.05.1a16.448 16.448 0 0 0 3.208 18.866l.273.265a16.635 16.635 0 0 0 13.893 4.383l.143-.024-.065.108a15.902 15.902 0 0 1-13.443 7.372c-8.776.002-15.889-7.069-15.889-15.786 0-7.207 4.885-13.341 11.618-15.2Z"
      })
    ], -1)
  ]));
}
const u = /* @__PURE__ */ l(r, [["render", s]]);
export {
  u as default
};
